import { useSidebarSafe } from "@/components/ui/sidebar";
import talentureLogo from "@assets/talenturelogo_1764931389327.png";

interface TalentureLogoProps {
  collapsed?: boolean;
  className?: string;
}

export function TalentureLogo({ collapsed, className = "" }: TalentureLogoProps) {
  const sidebarContext = useSidebarSafe();
  
  let isCollapsed = collapsed;
  if (isCollapsed === undefined && sidebarContext) {
    isCollapsed = sidebarContext.state === "collapsed";
  }
  if (isCollapsed === undefined) {
    isCollapsed = false;
  }
  
  if (isCollapsed) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div className="relative flex items-center">
          <span 
            className="text-2xl font-bold text-foreground leading-none"
            style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
          >
            t
          </span>
          <span 
            className="absolute -top-0.5 -right-1.5 w-2 h-2 rounded-full"
            style={{ backgroundColor: 'hsl(248, 45%, 48%)' }}
          />
        </div>
      </div>
    );
  }
  
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={talentureLogo} 
        alt="talenture" 
        className="h-6 w-auto object-contain"
        data-testid="img-logo-talenture"
        {...({ fetchpriority: "high" } as Record<string, string>)}
        loading="eager"
        width="1364"
        height="271"
      />
    </div>
  );
}

export function TalentureLogoStandalone({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src={talentureLogo} 
        alt="talenture" 
        className="h-7 w-auto object-contain"
        data-testid="img-logo-talenture-standalone"
        {...({ fetchpriority: "high" } as Record<string, string>)}
        loading="eager"
        width="1364"
        height="271"
      />
    </div>
  );
}

export default TalentureLogo;
